/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpLeftIcon20Solid = forwardRef('ArrowDRadiusUpLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.616 2.116a1.25 1.25 0 1 1 1.768 1.768L5.018 7.25H10.5a8.25 8.25 0 0 1 8.25 8.25v1a1.25 1.25 0 0 1-2.5 0v-1a5.75 5.75 0 0 0-5.75-5.75H5.018l3.366 3.366a1.25 1.25 0 0 1-1.768 1.768l-4.44-4.44a2.75 2.75 0 0 1 0-3.889l4.44-4.439Z" })));
});
